import style from "./style.scss";
import { useState, useRef, useEffect } from "preact/hooks";
import Link from "../../link";
import IconMenu from "../../icons/menu/index.js";
import SubMenu from "./sub-menu";
import { mergeClasses } from "../../helpers";
import namedRoutes from "../../../settings/routes";
import enabledFeatures from "../../../settings/enabledFeatures";

const Navigation = () => {
  const [menuActive, setMenuActive] = useState(false);
  const navRef = useRef(null);

  const handleToggle = () => {
    setMenuActive(!menuActive);
  };

  const handleClickOutside = (event) => {
    if (navRef.current && !navRef.current.contains(event.target)) {
      // Close the menu if clicked outside
      setMenuActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <nav
      class={mergeClasses([style.nav, menuActive ? style.menuActive : null])}
      aria-label="Main navigation"
    >
      <button
        class={style.toggleButton}
        aria-label="Toggle menu"
        onClick={handleToggle}
        ref={navRef}
      >
        <span class={style.buttonText}>Menu</span>
        <span class={style.buttonIcon}>
          <IconMenu open={menuActive} />
        </span>
      </button>
      <ul class={style.items} role="menu">
        <li role="menuitem">
          <Link activeClassName={style.current} href={namedRoutes.home}>
            Home
          </Link>
        </li>
        <li role="menuitem">
          <Link activeClassName={style.current} href={namedRoutes.whyAttend}>
            Why Attend
          </Link>
        </li>
        {enabledFeatures.speakers ? (
          <li role="menuitem">
            <Link activeClassName={style.current} href={namedRoutes.speakers}>
              Speakers
            </Link>
          </li>
        ) : null}
        <li role="menuitem">
          <Link activeClassName={style.current} href={namedRoutes.details}>
            Details
          </Link>
        </li>
        <SubMenu />
      </ul>
    </nav>
  );
};

export default Navigation;
